import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { NotificationService } from '../services/notification.service';

/**
 * Interceptor que maneja errores de autenticación (401) y CORS
 * Si el token es inválido o expiró, cierra la sesión automáticamente
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const notificationService = inject(NotificationService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Error CORS (status 0)
      if (error.status === 0) {
        console.error('❌ Error CORS detectado:', {
          url: req.url,
          message: error.message,
          error: error
        });
        
        // Si es un error CORS en una petición autenticada (no en login)
        if (!req.url.includes('/auth/login')) {
          console.warn('⚠️ Error CORS en petición autenticada. Posible problema de configuración del servidor.');
          notificationService.showError(
            'Error de comunicación con el servidor. Verifica tu conexión o contacta al administrador.'
          );
        }
        
        return throwError(() => error);
      }

      // Si el error es 401 (Unauthorized) y no es la ruta de login
      if (error.status === 401 && !req.url.includes('/auth/login')) {
        console.warn('🔒 Token inválido o expirado (401). Mostrando notificación...');
        
        // Mostrar notificación al usuario
        notificationService.showWarning('Tu sesión ha expirado. Por favor, inicia sesión nuevamente.');
        
        // NO hacer logout automático - dejar que el usuario vea el error primero
        // El usuario será redirigido al login cuando navegue manualmente
      }

      // Re-lanzar el error para que los componentes puedan manejarlo si lo necesitan
      return throwError(() => error);
    })
  );
};
